/*eslint-disable*/
import { Skeleton } from '@mui/material';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import image from '../../assets/images/house.jpg';
import { imageUrl } from '../../config/apiUrl';
import { useLazyGetApiQuery } from '../../store/apiSlice/apiSlice';
import { removeSinglePropertyProjectsAndEvents } from '../../store/notification/notificationSlice';
import NoData from '../NoData/NoData';
import classes from './HeaderNotification.module.css';

const Notifications = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [getApiFunc] = useLazyGetApiQuery();
  const { selectedLanguage } = useSelector((state) => state.languageReducer);

  // markAsRead
  const markAsRead = async (id) => {
    await getApiFunc({
      url: `notifications/seen/${id}`,
      tag: `Notifications`
    });
  };

  return (
    <div
      className={[classes.HeaderNotificationInnerDiv]}
      onClick={() => {
        if (item?.seen === false) {
          markAsRead(item?._id);
        }

        dispatch(removeSinglePropertyProjectsAndEvents(item?._id));

        if (
          ['follow-unfollow', 'package-expire', 'credit', 'package-upgrade', 'message'].includes(
            item?.flag
          )
        )
          return;
        const thePath = `${item?.path}${item?.query ? item?.query : ''}`;
        navigate(thePath);
      }}>
      <div className={[classes.ImgDiv]}>
        <img
          src={imageUrl(item[item?.flag]?.images?.[0])}
          alt=""
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = image;
          }}
        />
      </div>
      <div className={[classes.contentDiv]}>
        <div className={[classes.titleDiv]}>
          <h6>{item?.title?.[selectedLanguage]}</h6>
        </div>
        <div className={classes.content}>
          <p>{item?.message?.[selectedLanguage]}</p>
          <div className={classes.time}>
            <p>{moment(item?.createdAt).format('Do MMM YYYY hh:mm a')}</p>
          </div>
        </div>
      </div>

      {item?.seen === false && <div className={classes?.notificationBadge}></div>}
    </div>
  );
};

const HeaderNotification = ({ t }) => {
  const [getApiFunc, { isLoading, isFetching, data: response }] = useLazyGetApiQuery();

  const navigate = useNavigate();

  const getData = async () => {
    await getApiFunc({
      url: `notifications/all?page=${1}&limit=${5}&sortBy=${-1}`,
      tag: `Notifications`
    });
  };
  const newArray5 = [1, 2, 3, 4, 5];

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className={[classes.HeaderNotification]}>
      <div className={[classes.notificationHeader]}>
        <h6>{t('webHeader.notificationsPopup.title')}</h6>
      </div>
      <div className={classes.notificationSkeleton}>
        {isLoading || isFetching ? (
          newArray5?.map((index) => (
            <Skeleton key={index} height={'80px'} width={'100%'} variant={'rectangular'} />
          ))
        ) : response?.data?.length == 0 ? (
          <NoData text={t('webHeader.notificationsPopup.noData')} className={classes.noData} />
        ) : (
          response?.data?.map((item, i) => {
            return (
              <div className={[classes.mb16]} key={i}>
                <Notifications item={item} />
              </div>
            );
          })
        )}
      </div>
      <p className={['p18', classes.viewAll].join(' ')} onClick={() => navigate('/notifications')}>
        {t('webHeader.notificationsPopup.seeAll')}
      </p>
    </div>
  );
};
export default HeaderNotification;
